export const FETCH_NOTIFICATION_BADGES = 'FETCH_NOTIFICATION_BADGES';
export const NOTIFICATION_BADGE_SUCCESS = 'NOTIFICATION_BADGE_SUCCESS';
export const NOTIFICATION_BADGE_ERROR = 'NOTIFICATION_BADGE_ERROR';
